var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleSmallRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3998 9.88006L10.8098 5.29006C10.6225 5.10381 10.369 4.99927 10.1048 4.99927C9.84065 4.99927 9.5872 5.10381 9.39983 5.29006C9.3061 5.38302 9.23171 5.49362 9.18094 5.61548C9.13017 5.73734 9.10403 5.86805 9.10403 6.00006C9.10403 6.13207 9.13017 6.26278 9.18094 6.38464C9.23171 6.5065 9.3061 6.6171 9.39983 6.71006L13.9998 11.2901C14.0936 11.383 14.168 11.4936 14.2187 11.6155C14.2695 11.7373 14.2956 11.868 14.2956 12.0001C14.2956 12.1321 14.2695 12.2628 14.2187 12.3846C14.168 12.5065 14.0936 12.6171 13.9998 12.7101L9.39983 17.2901C9.21153 17.477 9.10521 17.7312 9.10428 17.9965C9.10334 18.2619 9.20786 18.5168 9.39483 18.7051C9.58181 18.8934 9.83593 18.9997 10.1013 19.0006C10.3667 19.0016 10.6215 18.897 10.8098 18.7101L15.3998 14.1201C15.9616 13.5576 16.2772 12.7951 16.2772 12.0001C16.2772 11.2051 15.9616 10.4426 15.3998 9.88006Z",
    fill: "#374957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleSmallRight);
export default __webpack_public_path__ + "static/media/angle-small-right.68a294e8846131ac43935304978ab873.svg";
export { ForwardRef as ReactComponent };